import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

interface Feature {
  name: string;
  isEnabled: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class FeatureService {
  private featureList: Feature[] = environment.featureList;

  constructor() { }

  isFeatureEnabled(featureName: string): boolean {
    const feature = this.featureList.find(f => f.name === featureName);
    return feature ? feature.isEnabled: false;
  }

}
